// Just a blank page for now
function Loading () {
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <div className="loader"></div>
        </div>
    );
}

export default Loading;